import React from "react";

import { COLOR_BLUE_BAYOUX } from "../../constants/styles";
import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";
import { Table } from "../../UI/Table";
import { TableCell } from "../../UI/TableCell";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";
import NoResults from "../../common/component/NoResults";
import { UserInviteSearchResultsTableBody } from "./UserInviteSearchResultsTableBody";

interface IProps {
  results: any[];
  searched: boolean;
  isGlobalSearch: boolean;
}

export const UserInviteSearchResultsTable: React.FC<IProps> = (props) => (
  <>
    {!!props.results.length && (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body2" color={COLOR_BLUE_BAYOUX}>
            {props.results.length} user(s) found
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Table padding="checkbox">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Subnetwork</TableCell>
                <TableCell>Unit</TableCell>
                <TableCell>Bedroom</TableCell>
                <TableCell>Import date</TableCell>
                <TableCell>Registered</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <UserInviteSearchResultsTableBody users={props.results} isGlobalSearch={props.isGlobalSearch} />
          </Table>
        </Grid>
      </Grid>
    )}
    {!props.results.length && props.searched && <NoResults />}
  </>
);
